import styled from '../../../styled';
import Body from './Body';
import Head from './Head';
const TableContainer = styled.div `
  width: 100%;
  overflow: auto;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  ${Body}, ${Head} {
    min-width: 40rem;
  }
`;
export default TableContainer;
//# sourceMappingURL=TableContainer.js.map